import { Alert, Box, Container, Stack, ThemeProvider } from '@mui/material';
import React from 'react';
import CrmDashboardBlockedState from './crmDashboard/CrmDashboardBlockedState';
import CrmDashboardHeaderBar from './crmDashboard/CrmDashboardHeaderBar';
import CrmDashboardTaskSection from './crmDashboard/CrmDashboardTaskSection';
import {
  CRM_DASHBOARD_THEME,
  CONTENT_GRID_ITEM_SX,
  CONTENT_GRID_SX,
  PAGE_BACKGROUND,
} from './crmDashboard/crmDashboardStyles';
import useCrmDashboardController from './crmDashboard/useCrmDashboardController';

export default function CrmDashboardPage({ connected, currentUser, setConnected, setError }) {
  const controller = useCrmDashboardController({
    connected,
    currentUser,
    setConnected,
    setError,
  });

  if (!connected) {
    return (
      <CrmDashboardBlockedState
        isMobile={controller.isMobile}
        isTenantWideView={controller.isTenantWideView}
      />
    );
  }

  const showDashboardContent = !controller.loadError && (!controller.isLoading || controller.hasLoadedData);

  return (
    <ThemeProvider theme={CRM_DASHBOARD_THEME}>
      <Box sx={{ background: PAGE_BACKGROUND, minHeight: '100vh', py: { xs: 2.5, md: 4 } }}>
        <Container maxWidth="xl">
          <Stack spacing={2}>
            <CrmDashboardHeaderBar
              counts={controller.counts}
              isLoading={controller.isLoading}
              isMobile={controller.isMobile}
              isTenantWideView={controller.isTenantWideView}
              onRefresh={controller.onRefresh}
              refreshDisabled={controller.isLoading}
            />

            {controller.loadError && <Alert severity="error">{controller.loadError}</Alert>}

            {showDashboardContent && (
              <Box sx={CONTENT_GRID_SX}>
                <Box sx={CONTENT_GRID_ITEM_SX}>
                  <CrmDashboardTaskSection {...controller.overdueSection} />
                </Box>
                <Box sx={CONTENT_GRID_ITEM_SX}>
                  <CrmDashboardTaskSection {...controller.dueTodaySection} />
                </Box>
                <Box sx={CONTENT_GRID_ITEM_SX}>
                  <CrmDashboardTaskSection {...controller.plannedSection} />
                </Box>
              </Box>
            )}
          </Stack>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
